import type { SVGProps } from 'react'
const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="shopping-cart_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#shopping-cart_svg__a)">
      <path d="M5.25 16.567q-.618 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.442-.44 1.06-.44t1.06.44q.44.442.44 1.06 0 .62-.44 1.06t-1.06.44m7.5 0q-.619 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.442-.44 1.06-.44t1.06.44q.44.442.44 1.06 0 .62-.44 1.06-.442.44-1.06.44m-8.025-12L6.42 8.111h5.232L13.6 4.567zM3.94 2.933h10.892q.51 0 .777.451a.88.88 0 0 1 .02.918l-2.56 4.625q-.215.388-.577.606a1.5 1.5 0 0 1-.794.217H6.151l-.784 1.433h8.95v1.634H5.25q-.893 0-1.342-.776t-.033-1.54L4.874 8.7 2.21 3.067H.683V1.433h2.545z" />
    </g>
  </svg>
)
export default SvgShoppingCart
